import React from 'react';

import './style.scss';
import ConfigService from "../../../../Services/api/Config";

export default class HeaderStats extends React.PureComponent {

  getFormattedTime = (t) => {
    let time = t;
    const hours = Math.floor(time / 3600);
    time = time - hours * 3600;
    let minutes = Math.floor(time / 60);
    let seconds = Math.floor(time - minutes * 60);
    if (minutes < 10) minutes = `0${minutes}`;
    if (seconds < 10) seconds = `0${seconds}`;
    return `${hours}:${minutes}:${seconds}`;
  };

  render() {
    const { stats } = this.props;
    const completed = (stats.status.progress * 100).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    const current = this.getFormattedTime(stats.time_spent.current);
    const average = this.getFormattedTime(stats.time_spent.my_average);
    const total = this.getFormattedTime(stats.time_spent.total_average);
    return (
      <div className='HeaderStats'>
        <div className='HeaderStats_Progress'>
          <div className='HeaderStats_Progress_Files' style={ { color: ConfigService.getColor('secondaryColor') } }>{ stats.status.completed } of { stats.status.total } files
            complete ({ completed }%)
          </div>
          <div className='HeaderStats_Progress_Bar'>
            <div className='HeaderStats_Progress_Bar_Fill'
                 style={ { width: `${completed}%`, backgroundColor: ConfigService.getColor('successColor') } } />
            <div className='HeaderStats_Progress_Bar_Measure HeaderStats_Progress_Bar_Measure_25'
                 style={ { color: ConfigService.getColor('tertiaryColor') } }>25</div>
            <div className='HeaderStats_Progress_Bar_Measure HeaderStats_Progress_Bar_Measure_50'
                 style={ { color: ConfigService.getColor('tertiaryColor') } }>50</div>
            <div className='HeaderStats_Progress_Bar_Measure HeaderStats_Progress_Bar_Measure_75'
                 style={ { color: ConfigService.getColor('tertiaryColor') } }>75</div>
          </div>
        </div>
        <div className='HeaderStats_Time'>
          <div className='HeaderStats_Time_Item'>
            <div className='HeaderStats_Time_Item_Label'>Time spent by me on this audit: <span
              className='HeaderStats_Time_Item_Value' style={ { color: ConfigService.getColor('secondaryColor') } }>{ current }</span></div>
          </div>
          <div className='HeaderStats_Time_Item'>
            <div className='HeaderStats_Time_Item_Label'>My average time on all audits: <span
              className='HeaderStats_Time_Item_Value' style={ { color: ConfigService.getColor('secondaryColor') } }>{ average }</span></div>
          </div>
          <div className='HeaderStats_Time_Item'>
            <div className='HeaderStats_Time_Item_Label'>Average time by all auditors on this audit: <span
              className='HeaderStats_Time_Item_Value' style={ { color: ConfigService.getColor('secondaryColor') } }>{ total }</span></div>
          </div>
        </div>
      </div>
    );
  }
}